<template><template v-for="(p, i) in parts" :key="i"><i v-if="p.name === 'zone'">{{ p.value }}</i><b v-else-if="p.name">{{ p.value }}</b><template v-else>{{ p.text }}</template></template></template>

<script setup>
// One translated alert sentence: the zone name in italics, the seconds in bold —
// the same markup the English alerts always had. See alertParts.js.
import { computed } from 'vue'
import { alertParts } from './alertParts'

const props = defineProps({
  msgKey: { type: String, required: true },
  zone: String,
  time: Number,
})
const parts = computed(() => alertParts(props.msgKey, { zone: props.zone, time: props.time }))
</script>
